import routing from './util/routing'
// import Foundation from 'foundation-sites';

const devicejs = require('device.js')
const imagesLoaded = require('imagesloaded')
const owlCarousel = require('owl.carousel')
const lightcase = require('lightcase')
const simplyScroll = require('vendor/jquery.simplyscroll.min.js')

$(function(){
  const app = new App();
})

class App {
  constructor(el) {
    this.el = el
    this.$el = $(el)
    this.initialize()
  }

  initialize() {
    var _this = this;
    // routing.js load後
    require.ensure([], ()=> {
      routing()
      this.common_scripts()
    })
  }

  common_scripts(){
    // common scripts
    console.log('common scripts here !');
    setCarousel();
    setUp();
  }
}

function setUp() {
  if($("#notify").length) {
    var notify_interval;
    notify_interval = setInterval(function(){
     $("#notify").addClass("notify-hide");
      clearInterval(notify_interval);
    }, 8000);
  }

  $("#philosophy-photos").simplyScroll({
    pauseOnHover: false,
    pauseOnTouch: false,
  });

  $('#project-preview a').click(function() {
    return false;
  });

  $('.more').click(function(){
    var target = $(this).attr("href").split('#')[1];
    var label = $(this).html().split('を')[0];
    if ($('.s-more-' + target).is(':visible')) {
      $(this).html(label + 'を表示');
    } else {
      $(this).html(label + 'を非表示');
    }
    $('.s-more-' + target).slideToggle();
  });

  $('.movie').click(function(){
    var html_str;
    var movie_str = $(this).attr("data-movie");
    var domain = movie_str.split('/')[2];
    if (domain == 'www.youtube.com') {
      html_str = '<iframe src="' + movie_str + '?rel=0&controls=0&showinfo=0&autoplay=1" frameborder="0" allowfullscreen></iframe>';
    } else if (domain == 'player.vimeo.com') {
      html_str = '<iframe src="' + movie_str + '?autoplay=1&title=0&byline=0&portrait=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
    }
    $(this).find('.preview, .playbtn').remove();
    $(this).append(html_str);
  });

  $('.header-account a, .close').click(function(){
    $('body').toggleClass('signin-nav-open');
  });

  if($('.s-list.update-list').length){
    var update_height_array = new Array();
    $('.s-list.update-list li').each(function() {
      var h = $(this).find('.update').height();
      console.log(h);
      update_height_array.push(h);
    });
    var max_height = Math.max.apply(null, update_height_array); //=> 8
    $('.s-list.update-list li').each(function() {
      $(this).find('.update').height(max_height)
    });
  }

  $('a[data-rel^=lightcase]').lightcase({
    inline: {
      width: '800px'
    },
    onStart: {
      start: function() {
        $('html, body').addClass('modal');
      }
    },
    onClose: {
      close: function() {
        $('html, body').removeClass('modal');
      }
    }
  });
}

function setCarousel () {
  $('.background.owl-carousel').owlCarousel({
    singleItem: true,
    items: 1,
    loop: true,
    autoplay: true,
    autoplayTimeout: 2800,
    autoplayHoverPause: false,
    animateOut: 'fadeOut',
    nav: false,
  });

  $('.history.owl-carousel').owlCarousel({
    singleItem: true,
    items: 1,
    loop: true,
    center: true,
    autoplay: true,
    nav: true,
    navText: ["<img src='/images/arrow_prev.svg' />", "<img src='/images/arrow_next.svg' />"],
    autoplayTimeout: 5000
  });

  $('.comments.owl-carousel').owlCarousel({
    singleItem: true,
    items: 1,
    loop: true,
    // autoplay: true,
    autoplayTimeout: 5000
  });
  $('.carousel.owl-carousel').owlCarousel({
    autoWidth: true,
    items: 4
  });
  $('.banner.owl-carousel').owlCarousel({
    center: true,
    items: 1,
    loop: true,
    nav: true,
    navText: ["<img src='/images/arrow_prev.svg' />", "<img src='/images/arrow_next.svg' />"],
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    responsive:{
      0:{
        stagePadding: 60,
      },
      640:{
        stagePadding: 160,
      }
    }
  });

  $('.mission-list.owl-carousel').owlCarousel({
    autoWidth: true,
    items: 4
  });


  $('.support-list.owl-carousel').owlCarousel({
    autoWidth: true,
    items: 4
  });
}



// WEBPACK FOOTER //
// ./app.js